















import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class PokemonNotFound extends Vue {
  @Prop()
  title!: string;

  @Prop()
  message!: string;

  @Prop()
  imageSrc!: string;

  @Prop()
  imageAlternateText!: string;
}
